import { useContext } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { EXPERIMENTS } from '@fiverr-private/listing_experiments';
import { AppContext } from '../../components/context/listingsContext';
import { allocateToClientExperiment } from '../../clientExperiments/clientUtils';
import useListingsPositionObserver from '../useListingsPositionObserver';

const usePromotedVideoStripListingRowObserver = (videoStripPositionStart: number) => {
    const { abTests } = getContext();
    const { clientExperimentsGroups } = useContext(AppContext);

    const experiment = EXPERIMENTS.PROMOTED_VIDEO_STRIP;
    const experimentGroup = Number(clientExperimentsGroups[experiment]);

    return useListingsPositionObserver(
        {
            shouldObserve: !!experimentGroup && videoStripPositionStart > 0,
            position: videoStripPositionStart,
        },
        () => {
            if (experimentGroup > 0) {
                if (!abTests[experiment]) {
                    allocateToClientExperiment(experiment, clientExperimentsGroups);
                }
            }
        }
    );
};

export default usePromotedVideoStripListingRowObserver;
